import config from "@/utils/Config";
import {get } from "@/utils/request";

export function getAnalysisData(params = {}) {
    return get(config.BASE_URL, config.getAnalysisDataUrl, params)
}

export function getCount(params = {}) {
    return get(config.BASE_URL, config.getCountUrl, params)
}